import { createSelector } from 'reselect';
import { AssignmentPresetsStateType } from './assignmentPresets.types';

const getSubState = (state: any) => state.assignmentPresets as AssignmentPresetsStateType;

const isSaving = createSelector(getSubState, (s) => s?.saving ?? false);
const hasConflict = createSelector(getSubState, (s) => s?.conflict ?? false);
const getLastSavedId = createSelector(getSubState, (s) => s?.lastSavedId);
const getPresetsForAccount = (accountId: string) =>
    createSelector(getSubState, (s) => s?.byAccount?.[accountId] ?? []);

export default { isSaving, hasConflict, getLastSavedId, getPresetsForAccount };
